import { queryClient } from '../api/api.config';

const getLocalStorage = () => {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch (_) {
    return null;
  }
};

const removeStoredItem = (storage, key) => {
  try {
    storage?.removeItem(key);
  } catch (_) {}
};

const removeSupabaseAuthTokens = (storage) => {
  try {
    Object.keys(storage || {})
      .filter(key => key.startsWith('sb-') && key.endsWith('-auth-token'))
      .forEach(key => storage.removeItem(key));
  } catch (_) {}
};

const clearCachedQueryState = () => {
  try {
    queryClient.clear();
  } catch (_) {}
};

export const clearClientIdentityState = () => {
  const storage = getLocalStorage();

  removeStoredItem(storage, 'user');
  removeStoredItem(storage, 'lastActiveLeagueSlug');
  removeStoredItem(storage, 'pendingTeam');

  clearCachedQueryState();
};

export const clearClientAuthState = () => {
  const storage = getLocalStorage();

  removeSupabaseAuthTokens(storage);
  clearClientIdentityState();
};
